import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-signpost",
  "use": "icon-signpost-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-signpost\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-signpost\">\r\n  <path d=\"M7 1.414V4h2V1.414a1 1 0 0 0-2 0z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M12.532 5H2v4h10.532l1.666-2-1.666-2zM2 4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H2z\" />\r\n  <path d=\"M7 10h2v6H7v-6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/signpost.svg
// module id = 6ZrY
// module chunks = 60